module.exports = __webpack_public_path__ + "img/header3.ccca12dd.jpeg";